import PamInquiryCardComponent from './PamInquiryCard';
import InquiryDetailsComponent from './InquiryDetails';
import InquiryHeaderComponent from './InquiryHeader';
import AssigneeAvatarComponent from './AssigneeAvatar';
import InquiryStatusLabelComponent, {
  InquiryStatusLabelVariants as VARIANTS,
} from './InquiryStatusLabel';
import ContactDetailsComponent from './ContactDetails';
import PhoneStatusBadgeComponent from './PhoneStatusBadge';
import InquirySourceBadgeComponent from './InquirySourceBadge';
import TagComponent from './Tag';

export const PamInquiryCard = PamInquiryCardComponent;
export const InquiryDetails = InquiryDetailsComponent;
export const InquiryHeader = InquiryHeaderComponent;
export const AssigneeAvatar = AssigneeAvatarComponent;
export const InquiryStatusLabel = InquiryStatusLabelComponent;
export const ContactDetails = ContactDetailsComponent;
export const PhoneStatusBadge = PhoneStatusBadgeComponent;
export const InquirySourceBadge = InquirySourceBadgeComponent;
export const Tag = TagComponent;

export { VARIANTS };
